<div class="container">
  <ul>
    <li>
      <a routerLink="/research">Research</a>
    </li>
    <li class="search-term" *ngIf="searchLink | async as search">
      <i class="k-icon k-font-icon k-i-arrow-chevron-right"></i>
      <i class="k-icon k-font-icon k-i-search"></i>
      <a [routerLink]="search.routerLink" [queryParams]="search.queryParams">
        Search</a
      >
    </li>

    <li class="sub" *ngIf="sub">
      <i class="k-icon k-font-icon k-i-arrow-chevron-right"></i>
      <span>{{ sub.type }}</span>
      <a routerLink="{{ sub.url }}">{{ sub.title }}</a>
    </li>

    <li class="sub" *ngIf="subSub">
      <i class="k-icon k-font-icon k-i-arrow-chevron-right"></i>
      <span>{{ subSub.type }}</span>
      <a routerLink="{{ subSub.url }}">{{ subSub.title }}</a>
    </li>
  </ul>
</div>
